import { type IDataObjectsState } from '@inpart-io/devtools-vue';
import { type ITemplateLeadSummary } from '@inpart-io/padme-iap';
import { type GetterTree } from 'vuex';

export const GET_BY_ASSET_TYPE = 'getByAssetType';

export const getters: GetterTree<IDataObjectsState<ITemplateLeadSummary>, unknown> = {
    [GET_BY_ASSET_TYPE]: (_state) => {
        return (assetType: string): ITemplateLeadSummary[] => {
            if (assetType?.length !== undefined) {
                return (
                    Array.from(_state.dataObjectList.values())?.filter((template: ITemplateLeadSummary) => {
                        return template.assetType === assetType;
                    }) ?? []
                );
            } else {
                return [];
            }
        };
    }
};
